'use client';

import { useCallback } from 'react';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { notify } from 'src/utils/notifications';
import { useGetTxParams } from '../transactions/useGetTxParams';

interface CancelInsuranceFundUnstakeOptions {
	marketIndex: number;
}

export const useCancelInsuranceFundUnstake = () => {
	const velocityClient = useVelocityStore((s) => s.velocityClient.client);
	const getTxParams = useGetTxParams();

	const cancelInsuranceFundUnstakeRequest = useCallback(
		async (opts: CancelInsuranceFundUnstakeOptions): Promise<boolean> => {
			if (!velocityClient) return false;

			const toastId = `cancel-unstake-from-if-${opts.marketIndex}`;

			notify({
				id: toastId,
				type: 'awaiting_wallet_confirmation',
				showUntilCancelled: true,
			});

			try {
				const _txid =
					await velocityClient.cancelRequestRemoveInsuranceFundStake(
						opts.marketIndex,
						getTxParams()
					);

				notify({
					id: toastId,
					type: 'success',
					message: 'Canceled unstake request.',
					showUntilCancelled: false,
				});

				return true;
			} catch (err: any) {
				console.log(err);
				notify({
					id: toastId,
					type: 'error',
					message: 'Failed to cancel unstake request.',
					description: `${err}`,
					showUntilCancelled: false,
				});
				return false;
			}
		},
		[velocityClient, getTxParams]
	);

	return { cancelInsuranceFundUnstakeRequest };
};
